import { addDays } from "date-fns";
import { map } from "rxjs";

import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import { ITurnTrackingParams } from "../TurnTracking.interface";
import { TurnTrackingSearch } from "./TurnTrackingSearch";
import { TurnTrackingTable } from "./TurnTrackingTable";

export const TurnTrackingResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: ITurnTrackingParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const withdrawal_from_date = getDateAttribute(
        params.withdrawal_from_date
      );
      const withdrawal_to_date = getDateAttribute(
        params.withdrawal_to_date,
        addDays(new Date(), 5)
      );
      const turn_status_option = getAttributeList(params.turn_status_option);
      return {
        ...params,
        volante_nums,
        withdrawal_from_date,
        withdrawal_to_date,
        turn_status_option,
      };
    })
  );

  return (
    <>
      <TurnTrackingSearch params$={params$} />
      <TurnTrackingTable params$={params$} />
    </>
  );
};
